<div class="selfscroll_body">
  <div class="row ml-2 mt-1 mx-1">
    <div class="col-md-6 col-lg-6">
      <div class="form-group">
        <div class="left inline control-label mb-1">Assessment Date From</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
            [(ngModel)]="selfAssessmentT2Filter.fromDate" readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>

    <div class="col-md-6 col-lg-6">
      <div class="form-group">
        <div class="left inline control-label d-none d-sm-block mb-1">Assessment Date To</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
            [(ngModel)]="selfAssessmentT2Filter.toDate" readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
          </div>
        </div>
        <mat-datepicker #toPicker></mat-datepicker>
      </div>
    </div>
    <div class="col-md-6 col-lg-6">
      <div class="form-group">
        <div class="left inline control-label mb-1">Key Words</div>
        <mat-chip-grid #keywordsList class="fix_mat_chip">
          <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.searchQuery" [selectable]="selectable"
            [removable]="removable" (removed)="remove(sQuery)">
            {{sQuery}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input rulebook-rule-idinput border-bottom" #keywordInput
            [formControl]="keyCtrl" [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let fK of filteredKeywords" [value]="fK">
            {{fK}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-md-6 col-lg-6">
      <div class="form-group">
        <div class="left inline control-label mb-1">Id</div>
        <input type="number" class="form-control rulebook-rule-idinput form-control-sm border-bottom"
        [(ngModel)]="rulebookRuleId">
      </div>
    </div>
  </div>

  <div class="row mt-1 mb-1 mx-1">
    <div class="col-12 accordions">
      <mat-accordion id="RulebookSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Rulebook Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Rulebook</div>
                <mat-chip-grid #rulebookList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.ruleBook" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRB(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" autocomplete="off"
                    [matChipInputFor]="rulebookList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRB($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Part</div>
                <mat-chip-grid #partList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.part" [selectable]="selectable"
                    [removable]="removable" (removed)="removePA(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #pAInput autocomplete="off"
                    [matChipInputFor]="partList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addPA($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Owner</div>
                <mat-chip-grid #ownerList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.owner" [selectable]="selectable"
                    [removable]="removable" (removed)="removeOW(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #oWInput
                    [formControl]="searchOWCntrl" [matAutocomplete]="oWAutocomplete" [matChipInputFor]="ownerList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addOW($event)">
                </mat-chip-grid>
                <mat-autocomplete #oWAutocomplete="matAutocomplete" (optionSelected)="selectedOWEvent($event)">
                  <mat-option *ngFor="let fK of searchedOwner" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Rule Text</div>
                <mat-chip-grid #ruletextList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.regulatoryRuleFullRequirement"
                    [selectable]="selectable" [removable]="removable" (removed)="removeRR(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #rRInput autocomplete="off"
                    [matChipInputFor]="ruletextList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRR($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="AssessmentSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Assessment Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Assessment Team</div>
                <mat-chip-grid #assessmentTeamList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.assessmentTeam" [selectable]="selectable"
                    [removable]="removable" (removed)="removeAT(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #aTInput
                    [formControl]="searchATCntrl" [matAutocomplete]="aTAutocomplete"
                    [matChipInputFor]="assessmentTeamList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addAT($event)">
                </mat-chip-grid>
                <mat-autocomplete #aTAutocomplete="matAutocomplete" (optionSelected)="selectedATEvent($event)">
                  <mat-option *ngFor="let fK of searchedAT" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Assessment Details</div>
                <mat-chip-grid #assessmentDetailList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.assessmentDetails"
                    [selectable]="selectable" [removable]="removable" (removed)="removeAD(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #aDInput autocomplete="off"
                    [matChipInputFor]="assessmentDetailList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addAD($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Assessment Status</div>
                <mat-chip-grid #assessmentStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.assessmentStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeAS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #aSInput
                    [formControl]="searchASCntrl" [matAutocomplete]="aSAutocomplete"
                    [matChipInputFor]="assessmentStatusList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addAS($event)">
                </mat-chip-grid>
                <mat-autocomplete #aSAutocomplete="matAutocomplete" (optionSelected)="selectedASEvent($event)">
                  <mat-option *ngFor="let fK of searchedAS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="left inline control-label mb-1">Compliance Status</div>
                <mat-chip-grid #complianceStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.complianceStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeCS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #cSInput
                    [formControl]="searchCSCntrl" [matAutocomplete]="cSAutocomplete"
                    [matChipInputFor]="complianceStatusList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addCS($event)">
                </mat-chip-grid>
                <mat-autocomplete #cSAutocomplete="matAutocomplete" (optionSelected)="selectedCSEvent($event)">
                  <mat-option *ngFor="let fK of searchedCS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="ReviewSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Review Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Reviewer Team</div>
                <mat-chip-grid #reviewTeamList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.reviewerTeam" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRT(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #rTInput
                    [formControl]="searchRTCntrl" [matAutocomplete]="rTAutocomplete" [matChipInputFor]="reviewTeamList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addRT($event)">
                </mat-chip-grid>
                <mat-autocomplete #rTAutocomplete="matAutocomplete" (optionSelected)="selectedRTEvent($event)">
                  <mat-option *ngFor="let fK of searchedRT" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Review Details</div>
                <mat-chip-grid #reviewDetailsList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.reviewDetails" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRD(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" #rDInput autocomplete="off"
                    [matChipInputFor]="reviewDetailsList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRD($event)">
                </mat-chip-grid>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Review Status</div>
                <mat-chip-grid #reviewStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.reviewStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeRS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #rSInput
                    [formControl]="searchRSCntrl" [matAutocomplete]="rSAutocomplete"
                    [matChipInputFor]="reviewStatusList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRS($event)">
                </mat-chip-grid>
                <mat-autocomplete #rSAutocomplete="matAutocomplete" (optionSelected)="selectedRSEvent($event)">
                  <mat-option *ngFor="let fK of searchedRS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="InterpretationSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Interpretation Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Interpretation</div>
                <mat-chip-grid #interpretationList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.interpretation" [selectable]="selectable"
                    [removable]="removable" (removed)="removeIP(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #iPInput
                    [formControl]="searchIPCntrl" [matAutocomplete]="iPAutocomplete"
                    [matChipInputFor]="interpretationList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addIP($event)">
                </mat-chip-grid>
                <mat-autocomplete #iPAutocomplete="matAutocomplete" (optionSelected)="selectedIPEvent($event)">
                  <mat-option *ngFor="let fK of searchedIP" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Interpretation Details</div>
                <mat-chip-grid #interpretationDetailsList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.interpretationDetails"
                    [selectable]="selectable" [removable]="removable" (removed)="removeID(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" autocomplete="off"
                    [matChipInputFor]="interpretationDetailsList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addID($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="DataJudgementsSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Judgements Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <div class="left inline control-label mb-1">Judgement</div>
                <mat-chip-grid #dataJudgementList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.judgement" [selectable]="selectable"
                    [removable]="removable" (removed)="removeDJ(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #dJInput
                    [formControl]="searchDJCntrl" [matAutocomplete]="dJAutocomplete" [matChipInputFor]="dataJudgementList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addDJ($event)">
                </mat-chip-grid>
                <mat-autocomplete #dJAutocomplete="matAutocomplete" (optionSelected)="selectedDJEvent($event)">
                  <mat-option *ngFor="let fK of searchedDJ" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">No. of Data Judgements</div>
                <input type="number" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentT2Filter.noOfJudgements">
              </div>
            </div> -->
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <div class="left inline control-label mb-1">Judgement Details</div>
                <mat-chip-grid #dataJudgementDetailsList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.judgementDetails" [selectable]="selectable"
                    [removable]="removable" (removed)="removeJD(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" autocomplete="off"
                    [matChipInputFor]="dataJudgementDetailsList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addJD($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="ComplianceGapsSection" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Limitations Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <div class="left inline control-label mb-1">Limitations</div>
                <mat-chip-grid #complianceGapsList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.gaps" [selectable]="selectable"
                    [removable]="removable" (removed)="removeCG(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #cGInput
                    [formControl]="searchCGCntrl" [matAutocomplete]="cGAutocomplete"
                    [matChipInputFor]="complianceGapsList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addCG($event)">
                </mat-chip-grid>
                <mat-autocomplete #cGAutocomplete="matAutocomplete" (optionSelected)="selectedCGEvent($event)">
                  <mat-option *ngFor="let fK of searchedCG" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">No. of Gaps</div>
                <input type="number" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentT2Filter.noOfGaps">
              </div>
            </div> -->
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <div class="left inline control-label mb-1">Limitations Details</div>
                <mat-chip-grid #complianceGapsDetailList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.gapDetail"
                    [selectable]="selectable" [removable]="removable" (removed)="removeGD(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" autocomplete="off"
                    [matChipInputFor]="complianceGapsDetailList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addGD($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="Enhancements" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Actions Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <div class="left inline control-label mb-1"> Actions </div>
                <mat-chip-grid #enhancementList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.enhancement" [selectable]="selectable"
                    [removable]="removable" (removed)="removeEN(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #eNInput
                    [formControl]="searchENCntrl" [matAutocomplete]="eNAutocomplete"
                    [matChipInputFor]="enhancementList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addEN($event)">
                </mat-chip-grid>
                <mat-autocomplete #eNAutocomplete="matAutocomplete" (optionSelected)="selectedENEvent($event)">
                  <mat-option *ngFor="let fK of searchedEN" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <!-- <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">No. of Enhancements</div>
                <input type="number" class="form-control form-control-sm border-bottom"
                [(ngModel)]="selfAssessmentT2Filter.noOfEnhancement">
              </div>
            </div> -->
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <div class="left inline control-label mb-1">Actions Details</div>
                <mat-chip-grid #enhancementDetailList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.enhancementDescription"
                    [selectable]="selectable" [removable]="removable" (removed)="removeED(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" autocomplete="off"
                    [matChipInputFor]="enhancementDetailList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addED($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion id="Approvals" class="mt-1">
        <mat-expansion-panel [expanded]="false" class="ia-expansion-panel pl-2">
          <mat-expansion-panel-header class="ia-mat-panel">
            <mat-panel-title>
              <span class="text-header inc-f">
                Search Approvals Section
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row ml-2 mt-1">
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Approval Team</div>
                <mat-chip-grid #approvalTeamList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.approvalTeam" [selectable]="selectable"
                    [removable]="removable" (removed)="removeAPT(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #apTInput
                    [formControl]="searchAPTCntrl" [matAutocomplete]="apTAutocomplete"
                    [matChipInputFor]="approvalTeamList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addAPT($event)">
                </mat-chip-grid>
                <mat-autocomplete #apTAutocomplete="matAutocomplete" (optionSelected)="selectedAPTEvent($event)">
                  <mat-option *ngFor="let fK of searchedAPT" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Approval Status</div>
                <mat-chip-grid #approvalStatusList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.approvalStatus" [selectable]="selectable"
                    [removable]="removable" (removed)="removeAPS(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm mat-autodd-input border-bottom" #apSInput
                    [formControl]="searchAPSCntrl" [matAutocomplete]="apSAutocomplete"
                    [matChipInputFor]="approvalStatusList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addAPS($event)">
                </mat-chip-grid>
                <mat-autocomplete #apSAutocomplete="matAutocomplete" (optionSelected)="selectedAPSEvent($event)">
                  <mat-option *ngFor="let fK of searchedAPS" [value]="fK.value" [title]="fK.name">
                    {{fK.name}}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="left inline control-label mb-1">Approval Comment</div>
                <mat-chip-grid #approvalCommentList>
                  <mat-chip-row *ngFor="let sQuery of selfAssessmentT2Filter.approvalComment"
                    [selectable]="selectable" [removable]="removable" (removed)="removeAPC(sQuery)">
                    {{sQuery}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                  <input class="form-control form-control-sm border-bottom" autocomplete="off"
                    [matChipInputFor]="approvalCommentList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addAPC($event)">
                </mat-chip-grid>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>

<div class="row regulatory_row mx-1 mt-1">
  <div class="col-12 pt-2">
    <div class="form-group mb-0 text-right">
      <span class="ml-2 btn btn-sm pl-1" (click)="resetFilters()">Reset</span>
      <button type="button" class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white" id="btn-search"
        (click)="TriggerAction()">Submit</button>
    </div>
  </div>
</div>